import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Gumball Poodle (b_1fc44661), pulled from Faire's
// live `GET /api/product-reviews/product/{product_token}` endpoint (review
// token pr_zzqfn2sdhu) — verbatim comment, real reviewer first name, location and rating.
export const review_gp4: FaireReviewEntity = {
  token: "review_gp4",
  type: "review",
  brandName: "Gumball Poodle",
  brandToken: "b_1fc44661",
  productToken: "p_b464dpjz8n",
  reviewType: "product",
  reviewerName: "Kent",
  reviewerLocation: "Boise, ID, United States",
  stars: 5,
  reviewText: "One of our very favorite companies to work with!! The new grip socks are already a hit with our customers, give them a try!",
  reviewDate: "Sep 14, 2026",
  meta: {
    source: "api" as const,
    importedAt: "2026-10-12T05:40:00.000Z",
    importedBy: "entity-db-cli",
  },
};
